import axios from '/src/common/axios'

export default {
  getList: function () {
    return axios.get('/api/journalIppsu/listForPatient', { })
  },
}